import theme from "@/styles/theme";
import styled from "styled-components";

export const RangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  background: linear-gradient(to top right, #a9884d 80%, #c8a05e 50%);
  box-sizing: border-box;
  opacity: 1;
  margin-bottom: 2vh;
  @media ${theme.devices.tablet} {
    display: flex;
    flex-direction: column;
    row-gap: 1vh;
  }
  .row {
    display: flex;
    flex-direction: row;
    column-gap: 2vw;
    align-items: center;
    width: 100%;
    @media ${theme.devices.tablet} {
      display: flex;
      flex-direction: column;
      row-gap: 1vh;
    }
  }
`;
export const RangeLabel = styled.label`
  font-size: ${theme.fontSize.md};
  font-family: sans-serif;
  color: ${theme.colors.palete.brownDark};
  white-space: nowrap;
  @media ${theme.devices.tablet} {
    white-space: normal;
  }
`;
export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  //background-color: ${theme.colors.palete.brownLighter};
  border-radius: 5px;
  width: 94%;
  place-self: center;
  height: fit-content;
  margin-bottom: 2vh;
  @media ${theme.devices.tablet} {
    width: 85%;
  }
`;
export const TopCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  column-gap: 1vw;
  width: 100%;
  flex: 5;
  margin-bottom: 1vh;
  margin-top: 2vh;
  @media ${theme.devices.tablet} {
    display: flex;
    flex-direction: column;
    margin-bottom: 0vh;
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  width: 100%;
  flex: 3;
  text-align: -webkit-center;
  margin-top: 3vh;
  @media ${theme.devices.tablet} {
    display: flex;
    flex-direction: column;
    row-gap: 3vh;
  }
`;
